module.exports = __webpack_public_path__ + "static/img/popup.d54e3f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pt/popup.png
// module id = vAMc
// module chunks = 0